// Shared calendar-grid helpers for the day pickers: the dashboard's MiniCalendar
// (single-day jump picker) and the resident quick view's RangeCalendar (status
// start/end range picker). Both render the same 6x7 Monday-first month grid.

export const WEEKDAYS = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const pad2 = (n: number) => String(n).padStart(2, "0");
const iso = (y: number, m: number, d: number) => `${y}-${pad2(m + 1)}-${pad2(d)}`;

/** Monday-first weekday index (0=Mon..6=Sun) of the 1st of a month — the grid's leading blanks. */
export const leadingBlanks = (y: number, m: number) => (new Date(Date.UTC(y, m, 1)).getUTCDay() + 6) % 7;

export interface DayCell {
  key: string;
  date: string; // YYYY-MM-DD
  day: number;
  out: boolean; // belongs to the adjacent month shown in the grid
}

/** 42 cells (6 rows x 7 cols) for a month, padded with the adjacent months' days. */
export function monthCells(y: number, m: number): DayCell[] {
  const start = new Date(Date.UTC(y, m, 1 - leadingBlanks(y, m)));
  const cells: DayCell[] = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start.getTime() + i * 86_400_000);
    cells.push({
      key: iso(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()),
      date: iso(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()),
      day: d.getUTCDate(),
      out: d.getUTCMonth() !== m,
    });
  }
  return cells;
}

/** Long-form weekday label for a YYYY-MM-DD date (aria-label on day buttons). */
export const fmtCell = (date: string) =>
  new Date(`${date}T00:00:00Z`).toLocaleDateString("en-GB", {
    weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "UTC",
  });
